"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantProfileModalView = void 0;
var ApplicantsProfileModal_1 = require("./ApplicantsProfileModal");
Object.defineProperty(exports, "ApplicantProfileModalView", { enumerable: true, get: function () { return ApplicantsProfileModal_1.ApplicantProfileModalView; } });
